import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  AddNewLAModal,
  Checkbox,
  RiderAlterationFormData,
  RiderAlterationService,
  // SelectOption,
  Title,
  LifeAssuredTable,
  AlterRiderTable,
  formatNumberWithComma,
  AppContext,
  SubTaskType,
  HealthcareDetailPanelModal,
  PolicyBenefitRegistrationBlock
} from '@pulseops/common'
import { VERIRiderAlteration } from '../../../../common/src/service/model/task-detail/RiderAlteration'
import { StyleSheet, Text, View } from 'react-native'
import { Controller, useForm, useFieldArray } from 'react-hook-form'
import { SectionContent } from '@pulseops/submission/common'
import { pipe } from 'fp-ts/lib/function'
import { ZIO } from '@mxt/zio'
import * as A from 'fp-ts/lib/Array'
import * as O from 'fp-ts/lib/Option'

type RiderAlterationProps = {
  detailData: VERIRiderAlteration
  policyNum: string
  basket: SubTaskType
}

export const RiderAlteration = (data: RiderAlterationProps) => {
  const { t, i18n } = useTranslation('requestInfo')
  // const [newRiderList, setNewRiderList] = React.useState<SelectOption[]>([])
  const [isShowPopup, setIsShowPopup] = React.useState<boolean>(false)
  const [newLAInfoIndex, setNewLAInfoIndex] = React.useState<number>(-1)
  const riderNameList: RiderAlterationService.RiderNameInfo[] = data?.detailData.riderNameList || []
  const { showToast } = React.useContext(AppContext.AppContextInstance)
  const [isOpenedHealthcareDetail, setIsOpenHealthcareDetail] = React.useState<boolean>(false)
  const [riderLAIndex, setRiderLAIndex] = React.useState<number>(0)
  const [riderSubindex, setRiderSubindex] = React.useState<number>(0)
  const [LABirthDate, setLABirthDate] = React.useState('')
  const healthcareMasterData = data.detailData.healthcareBenefitMasterData
  const riderAlterationForm = useForm<RiderAlterationFormData.RiderAlteration>({
    defaultValues: {
      LARiderAlterationList: [],
      isAddRider: false,
      isRiderAlteration: false,
      newRiderLAList: [],
      isShowBenefitsRegistrationBlock: false,
      isCheckedBenefitsRegistrationBlock: false
    }
  })

  const LAFieldList = useFieldArray({
    control: riderAlterationForm.control,
    name: 'LARiderAlterationList'
  })

  const NewRiderLAList = useFieldArray({
    control: riderAlterationForm.control,
    name: 'newRiderLAList'
  })

  React.useEffect(() => {
    if (data.detailData) {
      const lifeAssuredAdditions = data.detailData.lifeAssuredAdditions
      pipe(
        lifeAssuredAdditions,
        A.map((lifeAssuredItem) => {
          return ZIO.succeed({
            lifeAssured: {
              ...lifeAssuredItem.lifeAssured,
              alteredRiderList: data.detailData.riderNameList.map((item) => ({ ...item, enable: item.enable }))
            }
          })
        }),
        ZIO.sequence,
        ZIO.map((lifeAssuredList) => {
          let riderFormArray: Array<RiderAlterationFormData.CurrentRiderForm> = []
          const LARiderItemList = data.detailData.lifeAssureds
          riderAlterationForm.setValue('isRiderAlteration', data.detailData.isRiderAlteration)
          riderAlterationForm.setValue('isAddRider', data.detailData.isAddLA)
          riderAlterationForm.setValue('isShowBenefitsRegistrationBlock', data.detailData.isCheckedBenefitsRegistrationBlock || false)
          riderAlterationForm.setValue('isCheckedBenefitsRegistrationBlock', data.detailData.isCheckedBenefitsRegistrationBlock || false)
          if (
            data.basket === SubTaskType.Verification &&
            lifeAssuredList.some((x) =>
              x.lifeAssured.riderListAdditional.some((p) =>
                riderNameList.some((k) => k.code === p.coverageCode && k.enable === false)
              )
            )
          ) {
            showToast(t('message:MS020109'), 'error', undefined, 8000)
          }
          LARiderItemList.map((LAItem) => {
            LAItem.coreRiders.map((rider) => {
              const productName = getRiderName(rider.productCode)
              const isWaiverProduct = data.detailData.waiverList.some((waiveritem) => waiveritem === rider.productCode)
              riderFormArray.push({
                riderCode: rider.productCode,
                riderName: productName,
                isWaiverProduct: isWaiverProduct,
                isClassNumber: false,
                classNumberList: [],
                // SelectRowForRider: false,
                riskCommDate: rider.riskCommDate,
                riskCessDate: rider.riskCessDate,
                sumAssured: rider.sumAssured,
                alteredSumAssured: rider.alteredSumAssured,
                installmentPrem: rider.installmentPremium,
                newInstallmentPremium: 0,
                lifeNo: rider.lifeNo,
                coverageNo: rider.coverageNo,
                riderNo: rider.riderNo,
                riderStatus: rider.riderStatus
              })
            })

            LAFieldList.append({
              // selectAllForLA: false,
              LAName: LAItem.clientName,
              lifeAssured: LAItem.lifeAssured,
              currentRiders: riderFormArray
            })

            riderFormArray = []
          })
          lifeAssuredList.map((lifeItem, index) => {
            // addNewRiderLAItem(index)
            const riderList = lifeItem.lifeAssured.riderListAdditional.map((riderItem) => {
              const riderInfo = getAlterRiderOptions(lifeItem.lifeAssured.alteredRiderList).find(
                (item) => item.value === riderItem.coverageCode
              ) || { value: '', label: '' }
              const healthcareBenefitDetailList = pipe(O.fromNullable(riderItem.healthcareBenefitDetailList),
                O.fold(
                  () => [],
                  (benefitList) => benefitList.map((benefitItem, benefitIndex) => {
                    const optionList = getSumAssuredOptionsByBenefitType(benefitItem.benefit)
                    const optionSA = pipe(
                      O.fromNullable(optionList.find((item) => item.value === benefitItem.optionSA)),
                      O.fold(
                        () => ({ label: '', value: '' }),
                        (item) => item
                      )
                    )
                    const copayOptionList = getCopayOptionsByBenefitType(benefitItem.benefit)
                    const copay = pipe(
                      O.fromNullable(copayOptionList.find((item) => item.value === benefitItem.copay)),
                      O.fold(
                        () => ({ label: '', value: '' }),
                        (item) => item
                      )
                    )
                    const benefitNameList = pipe(
                      O.fromNullable(healthcareMasterData?.body.healthCareBenefitList),
                      O.fold(
                        () => [],
                        (healthCareBenefitList) => healthCareBenefitList
                      )
                    )
                    const benefitName = i18n.language === 'vi' ? benefitNameList[benefitIndex].valueVi : benefitNameList[benefitIndex].valueEn
                    return {
                      isCheckedBenefit: benefitItem.isCheckedBenefit,
                      benefit: benefitItem.benefit,
                      benefitName: benefitName,
                      sumAssured: benefitItem.sumAssured,
                      optionSA: optionSA,
                      copay: copay,
                      term: benefitItem.term,
                      isDisabledCopay: true
                    }
                  })
                )
              )
              return {
                riderName: riderInfo,
                sumAssured: riderItem.sumAssured.toString(),
                policyPeriod: riderItem.policyPeriod.toString(),
                isWaiverProduct: false,
                isClassNumber: false,
                classNumberList: [],
                healthcareBenefitDetailList: healthcareBenefitDetailList
              }
            })
            const isCheckedBenefitsRegistration = lifeItem.lifeAssured.isCheckedBenefitsRegistration || false
            const riderNameForbenefitsRegistration = pipe(
              O.fromNullable(data.detailData.riderNameList.find((p) => p.code === lifeItem.lifeAssured.benefitsRegistrationRiderInfo?.riderName)),
              O.map((item) => ({ label: i18n.language === 'en' ? item.name : item.nameVi, value: item.code })),
              O.getOrElse(() => ({ label: '', value: '' }))
            )
            const benefitsRegistrationRiderInfo = isCheckedBenefitsRegistration ? {
              riderName: riderNameForbenefitsRegistration,
              sumAssured: lifeItem.lifeAssured.benefitsRegistrationRiderInfo?.sumAssured || '',
              policyPeriod: lifeItem.lifeAssured.benefitsRegistrationRiderInfo?.policyPeriod || '',
              riderType: lifeItem.lifeAssured.benefitsRegistrationRiderInfo?.riderType || ''
            } : undefined
            NewRiderLAList.insert(index, {
              LAName: lifeItem.lifeAssured.fullName,
              lifeAssured: '',
              isNewLA: lifeItem.lifeAssured.isNewLA ? true : false,
              newRiderList: riderList,
              detailData: lifeItem.lifeAssured,
              alteredRiderList: lifeItem.lifeAssured.alteredRiderList,
              isCheckedBenefitsRegistration: isCheckedBenefitsRegistration,
              isNewLAForBenefitsRegistration: lifeItem.lifeAssured.isNewLAForBenefitsRegistration || false,
              lifeAssuredType: lifeItem.lifeAssured.lifeAssuredType || '',
              benefitsRegistrationRiderInfo: benefitsRegistrationRiderInfo
            })
            riderAlterationForm.setValue(`newRiderLAList.${index}.LAName`, lifeItem.lifeAssured.fullName)
            riderAlterationForm.setValue(`newRiderLAList.${index}.lifeAssured`, '')
            riderAlterationForm.setValue(`newRiderLAList.${index}.isNewLA`, lifeItem.lifeAssured.isNewLA ? true : false)
            riderAlterationForm.setValue(`newRiderLAList.${index}.newRiderList`, riderList)
            riderAlterationForm.setValue(`newRiderLAList.${index}.detailData`, lifeItem.lifeAssured)
            riderAlterationForm.setValue(
              `newRiderLAList.${index}.alteredRiderList`,
              lifeItem.lifeAssured.alteredRiderList
            )
            riderAlterationForm.setValue(`newRiderLAList.${index}.isCheckedBenefitsRegistration`, isCheckedBenefitsRegistration)
            riderAlterationForm.setValue(`newRiderLAList.${index}.isNewLAForBenefitsRegistration`, lifeItem.lifeAssured.isNewLAForBenefitsRegistration || false)
            riderAlterationForm.setValue(`newRiderLAList.${index}.lifeAssuredType`, lifeItem.lifeAssured.lifeAssuredType || '')
            riderAlterationForm.setValue(`newRiderLAList.${index}.benefitsRegistrationRiderInfo`, benefitsRegistrationRiderInfo)
          })
        }),
        ZIO.unsafeRun({})
      )
    }
  }, [data.detailData])

  const getRiderName = (riderCode: string) => {
    const item = riderNameList.find((x) => x.code === riderCode)
    return !!item ? riderCode + ' - ' + (i18n.language === 'en' ? item.name : item.nameVi) : ''
  }

  const getAlterRiderOptions = (riderArr: RiderAlterationService.RiderNameInfo[]) => {
    const riderList = riderArr.map((item) => ({
      label: item.code + ' - ' + (i18n.language === 'en' ? item.name : item.nameVi),
      value: item.code
    }))
    return riderList
  }

  const closeAddLAModal = () => {
    setIsShowPopup(false)
  }

  const viewLADetail = (index: number) => {
    setNewLAInfoIndex(index)
    setIsShowPopup(true)
  }

  const openViewDetailPopUp = () => {
    const veriDetailData = riderAlterationForm.watch(`newRiderLAList.${newLAInfoIndex}.detailData`)
    console.log('viewItem', veriDetailData)
    return isShowPopup ? (
      <AddNewLAModal
        title={t('RiderAlteration:NewLAInformation')}
        isVisible={isShowPopup}
        isConfirmed={true}
        onClose={closeAddLAModal}
        isDetailView={true}
        detailIndex={newLAInfoIndex}
        veriDetailData={veriDetailData}
        riderAlterationForm={riderAlterationForm}
        // NewRiderLAList={NewRiderLAList}
        onSuccess={() => { }}
      />
    ) : (
      <></>
    )
  }
  const formatCurrency = (value: number | string | undefined) => {
    return !!value ? formatNumberWithComma(value) : '0'
  }

  const onEditRiderEvent = (index: number, subIndex: number, riderCode: string) => {
    setRiderLAIndex(index)
    setRiderSubindex(subIndex)
    if (riderCode === 'HCR9') {
      setIsOpenHealthcareDetail(true)
      setLABirthDate(riderAlterationForm.watch(`newRiderLAList.${index}.LADateOfBirth`) || '')
    } else {
      setIsOpenHealthcareDetail(false)
      setLABirthDate('')
    }
  }
  const getSumAssuredOptionsByBenefitType = (benefitType: string) => {
    switch (benefitType) {
      case "IP":
        return healthcareMasterData.body.ipOptionList.map((item) => ({ label: item.name, value: item.value }))
      case "OP":
        return healthcareMasterData.body.opOptionList.map((item) => ({ label: item.name, value: item.value }))
      case "DE":
        return healthcareMasterData.body.deOptionList.map((item) => ({ label: item.name, value: item.value }))
      case "MA":
        return healthcareMasterData.body.maOptionList.map((item) => ({ label: item.name, value: item.value }))
      default:
        return []
    }
  }

  const getCopayOptionsByBenefitType = (benefitType: string) => {
    switch (benefitType) {
      case "IP":
        return [{ label: "Y", value: "Y" }, { label: "N", value: "N" }]
      default:
        return [{ label: "Y", value: "Y" }]
    }
  }

  return (
    <View>
      <Title title={t('RIDERALTERATIONINFORMATION')} />
      <Controller
        control={riderAlterationForm.control}
        name={'isRiderAlteration'}
        render={({ field: { value, onChange, onBlur } }) => (
          <Checkbox
            title={t('RiderAlteration:RiderAlteration')}
            onChange={(checked) => {
              onChange(checked)
              // changeEventForLA(checked, index, fieldItem)
            }}
            onBlur={onBlur}
            value={value}
            disabled={true}
            checkBoxStyle={styles.tableCheckBox}
          />
        )}
      />
      {riderAlterationForm.watch('isRiderAlteration') && (
        <SectionContent sectionStyles={{ backgroundColor: '#fff' }}>
          <LifeAssuredTable
            riderAlterationForm={riderAlterationForm}
            LAFieldList={LAFieldList}
            isConfirmed={true}
            isVerificationScreen={true}
          ></LifeAssuredTable>
        </SectionContent>
      )}
      <View style={styles.secondLine}>
        <Controller
          control={riderAlterationForm.control}
          name={'isAddRider'}
          render={({ field: { value, onChange, onBlur } }) => (
            <Checkbox
              title={t('RiderAlteration:AddRider')}
              onChange={(checked) => {
                onChange(checked)
                // changeEventForLA(checked, index, fieldItem)
              }}
              onBlur={onBlur}
              value={value}
              disabled={true}
              checkBoxStyle={styles.tableCheckBox}
            />
          )}
        />
      </View>
      {riderAlterationForm.watch('isAddRider') && (
        <SectionContent sectionStyles={{ backgroundColor: '#fff' }}>
          <AlterRiderTable
            // newRiderList={newRiderList}
            riderAlterationForm={riderAlterationForm}
            NewRiderLAList={NewRiderLAList}
            disabled={true}
            // addNewRider={addNewRiderForExistedLA}
            // removeRider={removeRiderForExistedLA}
            // removeNewLA={removeNewLA}
            viewLADetail={viewLADetail}
            isVerificationScreen={true}
            onEditRiderEvent={onEditRiderEvent}
          ></AlterRiderTable>
        </SectionContent>
      )}
      {riderAlterationForm.watch('isShowBenefitsRegistrationBlock') && (
        <View style={styles.secondLine}>
          <Controller
            control={riderAlterationForm.control}
            name={'isCheckedBenefitsRegistrationBlock'}
            render={({ field: { value, onChange, onBlur } }) => (
              <Checkbox
                title={t('RiderAlteration:PolicyBenefitsRegistration')}
                onChange={(checked) => {
                  onChange(checked)
                }}
                onBlur={onBlur}
                value={value}
                disabled={true}
                checkBoxStyle={styles.tableCheckBox}
              />
            )}
          />

        </View>
      )}
      {riderAlterationForm.watch('isCheckedBenefitsRegistrationBlock') && (
        <SectionContent sectionStyles={{}}>
          <PolicyBenefitRegistrationBlock
            isConfirmed={true}
            riderAlterationForm={riderAlterationForm}
            NewRiderLAList={NewRiderLAList}
            riderNameList={data.detailData.riderNameList}
            onViewLADetailEvent={viewLADetail}
          />
        </SectionContent>
      )}
      {openViewDetailPopUp()}
      <View style={styles.secondLine}>
        <Text style={styles.text}>{t('submission:RequirePayInAmount')}</Text>
        <Text style={styles.isHightLight}>{formatCurrency(data?.detailData.requiredPayInAmount)} VND</Text>
      </View>
      <HealthcareDetailPanelModal
        isOpen={isOpenedHealthcareDetail}
        title={t('HealthcareDetailPopup:HealthcareDetailPanel')}
        riderAlterationForm={riderAlterationForm}
        riderLAIndex={riderLAIndex}
        riderSubIndex={riderSubindex}
        onClose={() => setIsOpenHealthcareDetail(false)}
        onConfirm={() => setIsOpenHealthcareDetail(false)}
        LABirthDate={LABirthDate}
        isDisabled={true}
      // riderAlterationDetailData={riderDetail}
      // healthcareBenefitMasterData={healthcareMasterDataResponse}
      />
    </View>
  )
}
const styles = StyleSheet.create({
  text: {
    fontSize: 16,
    marginBottom: 10
  },
  isHightLight: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#eD1B2E'
  },
  tableCheckBox: {
    padding: 0,
    marginTop: 0,
    paddingLeft: 10
  },
  secondLine: {
    marginTop: 20
  },
  panelContent: {
    backgroundColor: '#fff',
    borderWidth: 0,
    borderColor: '#fff'
  },
  hightLightText: {
    color: '#ED1B2E'
  }
})
